import * as z from 'zod';

import { type AuditId } from './audit';
import { AuditBackgroundFormSchema } from './audit-background-form';
import { AuditMechanicalFormSchema } from './audit-mechanical-form';
import { AuditLightingTypeFormSchema } from './audit-lighting-type-form';
import { AuditLightingCountFormSchema } from './audit-lighting-count-form';
import { AuditWaterFixtureFormSchema } from './audit-water-fixture-form';
import { AuditWindowsFormSchema } from './audit-windows-form';
import { AuditChecklistFormSchema } from './audit-checklist-form';
import { AuditEcmsFormSchema } from './audit-ecms-form';

export const AuditFormSchema = z.discriminatedUnion('type', [
  AuditBackgroundFormSchema,
  AuditMechanicalFormSchema,
  AuditLightingTypeFormSchema,
  AuditLightingCountFormSchema,
  AuditWaterFixtureFormSchema,
  AuditWindowsFormSchema,
  AuditChecklistFormSchema,
  AuditEcmsFormSchema,
]);

export type AuditForm = z.infer<typeof AuditFormSchema>;
export type AuditFormType = AuditForm['type'];

export class AuditFormNotFoundError extends Error {
  constructor(auditId: AuditId, formType: AuditFormType) {
    super(
      `Audit form of type "${formType}" for audit with ID "${auditId}" not found`,
    );
    this.name = 'AuditFormNotFoundError';
  }
}
